// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"e955aa4b","67":"e955aa4b","474":"af8fb1b2","784":"e955aa4b","890":"683d22d9"}[chunkId] + ".chunk.css";
};